(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-competition/assets/javascripts/hooks/use-draws.js') >= 0) return;  svs.modules.push('/components/tipsen/route-competition/assets/javascripts/hooks/use-draws.js');
"use strict";


const {
  useEffect,
  useContext,
  useRef,
  useState
} = React;
const {
  useSelector,
  useDispatch
} = ReactRedux;
const {
  loadDrawByProduct
} = svs.components.sport.drawsRedux.actions;
const {
  selectors: {
    makeSelectDrawsByDrawNumber
  },
  engine: {
    EngineProviderContext
  }
} = svs.components.tipsen;
const {
  useMemoizedSelector
} = svs.components.lbUtils.hooks;

const useDraws = _ref => {
  let {
    drawNumbers: _drawNumbers,
    productId: _productId = null
  } = _ref;
  const {
    currentEngine
  } = useContext(EngineProviderContext);
  const [productIdByEngine] = currentEngine.drawProductIds;
  const productId = _productId || productIdByEngine;
  const prevDrawNumbers = useRef(_drawNumbers);
  const [drawNumbers, setDrawNumbers] = useState(_drawNumbers);
  useEffect(() => {
    const isSame = _drawNumbers.every((drawNumber, index) => drawNumber === prevDrawNumbers.current[index]);
    if (!isSame || _drawNumbers.length !== prevDrawNumbers.current.length) {
      prevDrawNumbers.current = _drawNumbers;
      setDrawNumbers(_drawNumbers);
    }
  }, [_drawNumbers]);
  const selectDraws = useMemoizedSelector(makeSelectDrawsByDrawNumber, productId, drawNumbers);
  const draws = useSelector(selectDraws);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadDrawByProduct({
      productId,
      drawNumber: drawNumbers,
      currentEngine
    }));
  }, [dispatch, productId, drawNumbers, currentEngine]);
  return draws;
};
setGlobal('svs.components.tipsen.routeCompetition.useDraws', useDraws);

 })(window);